module.exports = __webpack_public_path__ + "static/media/setting.a2cb5f17.svg";